import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-chat-smile-2-line text-xl" />
              </span>
              <strong className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</strong>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              {siteInfo.description}
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
                aria-label="发送邮件"
              >
                <i className="ri-mail-line" />
              </a>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100">
                <i className="ri-bookmark-3-line" />
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">内容分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/stories?category=${cat.slug}`}
                    className="text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-200 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/stories" className="text-sm text-background-200 transition-colors hover:text-accent-300">
                  全部趣闻
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/#subscribe" className="text-sm text-background-200 transition-colors hover:text-accent-300">
                  订阅热瓜
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {siteInfo.startYear}–2026 {siteInfo.name} · 记录高校吃瓜趣闻与日常
          </p>
          <p>内容均为校园生活故事整理，人物与高校信息已做模糊化处理</p>
        </div>
      </div>
    </footer>
  );
}